import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './embla-carousel-arrow-buttons';
import { addDotBtnsAndClickHandlers } from './embla-carousel-dot-button';

const OPTIONS: EmblaOptionsType = {
  align: 'start',
  containScroll: 'trimSnaps',
  loop: false,
  slidesToScroll: 1,
};

export function initCarouselBlocks(): void {
  const emblaNodes = document.querySelectorAll<HTMLElement>('.embla');
  if (!emblaNodes.length) return;

  emblaNodes.forEach(emblaNode => {
    const viewportNode = emblaNode.querySelector<HTMLElement>('.embla__viewport');
    const prevBtnNode = emblaNode.querySelector<HTMLElement>('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector<HTMLElement>('.embla__button--next');
    const dotsNode = emblaNode.querySelector<HTMLElement>('.embla__dots');

    if (!viewportNode || !prevBtnNode || !nextBtnNode || !dotsNode) return;

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);

    const updateControlVisibility = (): void => {
      const canScroll = emblaApi.canScrollNext() || emblaApi.canScrollPrev();
      const totalSlides = emblaApi.slideNodes().length;

      if (!canScroll || totalSlides <= 1) {
        emblaNode.classList.add('embla--no-controls');
      } else {
        emblaNode.classList.remove('embla--no-controls');
      }
    };

    emblaApi.on('init', updateControlVisibility);
    emblaApi.on('reInit', updateControlVisibility);

    emblaApi.on('destroy', () => {
      removePrevNextBtnsClickHandlers();
      removeDotBtnsAndClickHandlers();
    });
  });
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarouselBlocks);
} else {
  initCarouselBlocks();
}
